// This should be enough for at least 7976 more years
export const numberOfDigits = 4